export default "__VITE_ASSET__2a10db79__$_?component__"